import React from 'react'
import Button from '@/components/ui/Buttons/Button'
import classes from './Home.module.scss'
import Typography from '@/components/ui/Typography'
import { Puff } from '@/components/ui/Loaders'
import { useStartRoute } from '@/lib/react-query'
import { useRedirectLoggedInUsers } from '@/features/auth'

export function HomePage() {
  useRedirectLoggedInUsers()
  const { isPending, mutate } = useStartRoute()

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Typography variant={'xxl'}>Solve big problems with small efforts</Typography>
        <Typography variant={'lg'}>
          Build software collaboratively with the power of AI, on any device, without spending a second on setup
        </Typography>
        <Button
          className={classes.button}
          onClick={() => mutate()}
          disabled={isPending}
          StartIcon={isPending && <Puff />}
        >
          Create a New Project
        </Button>
      </div>
    </div>
  )
}
